var map = {
	"./35_Black_Scene.jpg": 1871,
	"./35_Freijo_Scene.jpg": 953,
	"./35_White_Scene.jpg": 3065,
	"./35_black.png": 3994,
	"./35_freijo.png": 1100,
	"./35_white.png": 7660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3036;